import { render } from "./Hydetails.vue?vue&type=template&id=039b7cc6&scoped=true"
import script from "./Hydetails.vue?vue&type=script&lang=js"
export * from "./Hydetails.vue?vue&type=script&lang=js"

import "./Hydetails.vue?vue&type=style&index=0&id=039b7cc6&lang=scss&scoped=true"
import "./Hydetails.vue?vue&type=style&index=1&id=039b7cc6&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-039b7cc6"]])

export default __exports__